import React from "react";
import Social from "../components/social/Social";

const SocialIcons = () => {
  return <Social />;
};

export default SocialIcons;
